import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { ScreenFullIcon } from '@primer/octicons-react';
import { PropTableValues } from '../../src/components';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Tooltip} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tooltip text="Sample tooltip content">
    <Button>Action</Button>
</Tooltip>
`}</code></pre>
    <h3>{`Custom direction`}</h3>
    <p>{`By default, tooltips appear below the element. You can change the direction by passing the `}<inlineCode parentName="p">{`direction`}</inlineCode>{` prop with a value of `}<inlineCode parentName="p">{`n`}</inlineCode>{`, `}<inlineCode parentName="p">{`e`}</inlineCode>{`, `}<inlineCode parentName="p">{`s`}</inlineCode>{`, or `}<inlineCode parentName="p">{`w`}</inlineCode>{`.`}</p>
    <p>{`As long as there is enough room in the viewport, the tooltip will appear in the specified direction. If there is not enough room, the tooltip will appear in whatever direction it can place the tooltip without overflowing the viewport.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tooltip text="Sample tooltip content" direction="e">
    <Button>Action</Button>
</Tooltip>
`}</code></pre>
    <h3>{`Substitute a visible label`}</h3>
    <p>{`If a ubiquitously understood icon is used in place of a text label, you can use the `}<inlineCode parentName="p">{`type`}</inlineCode>{` to provide a text label for assistive technologies such as screen readers.`}</p>
    <p>{`Use this with caution. It is generally better to use a visible label for better usability and accessibility.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Tooltip text="Go fullscreen" type="label">
    <Button hasArrow={false}><ScreenFullIcon /></Button>
</Tooltip>
`}</code></pre>
    <h2>{`Component props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`direction`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['n', 'e', 's', 'w']} mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'s'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The side the tooltip appears on`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The text to be displayed in the tooltip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`type`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={['description', 'label']} mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`'description'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of tooltip. `}<inlineCode parentName="td">{`label`}</inlineCode>{` is used for labelling the element that triggers tooltip. `}<inlineCode parentName="td">{`description`}</inlineCode>{` is used for describing or adding a suplementary information to the element that triggers the tooltip.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      